import { ProductTypeEnum } from '@seller-area/pages/customer-panel/customer-details/create-unit/helpers';
import { SubmarketEnum } from '@seller-area/utils/translators/proposal';

export const SUBMARKET_LABEL: Record<string, string> = {
  NORTH: SubmarketEnum.NORTH,
  NORTHEAST: SubmarketEnum.NORTHEAST,
  SOUTH: SubmarketEnum.SOUTH,
  SOUTHEAST: SubmarketEnum.SOUTHEAST,
};

export const PRODUCT_LABEL: Record<string, string> = {
  CLARKE_MANAGEMENT: ProductTypeEnum.CLARKE_MANAGEMENT,
  CLARKE_RETAIL: ProductTypeEnum.CLARKE_RETAIL,
  RETAIL_TRANSFER: ProductTypeEnum.RETAIL_TRANSFER,
  WHOLESALE_TRANSFER: ProductTypeEnum.WHOLESALE_TRANSFER,
};
